import { Modal } from 'antd';
import { ResolvedImage } from '../../media/ResolvedImage';

interface Props {
  open: boolean;
  mediaSrc: string | null;
  name: string;
  onClose: () => void;
}

/** Full-size lightbox for the profile photo. */
export default function PhotoViewer({ open, mediaSrc, name, onClose }: Props) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width="min(92vw, 560px)"
      title={<span style={{ color: '#FAF7F0' }}>{name}</span>}
      styles={{
        body: { backgroundColor: '#101614', padding: 16 },
        header: { backgroundColor: '#101614', marginBottom: 12 },
      }}
    >
      {mediaSrc && (
        <ResolvedImage
          mediaSrc={mediaSrc}
          alt={name}
          className="mx-auto block max-h-[70vh] w-auto rounded-lg object-contain"
        />
      )}
    </Modal>
  );
}
